import SeasonInput from "@/widgets/Inputs/SeasonInput.vue";

export default {
	data() {
		return {
			filterSeason: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterSeason._id": {
			handler(val) {
				let fieldName = "season";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	},
	components: {
		SeasonInput
	}
};
